export default __webpack_public_path__ + "static/media/Skoleophold_tarmrenser.cc50dc30.png";